/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../../shared/theme/public-api';
import { posSharedUi as posUi } from './posSharedUi';

type Props = {
  title: string;
};

/** Título del listado (cards / tabla) debajo de filtros. */
export function OperationalListSectionHeader({ title }: Props) {
  return (
    <View style={styles.wrap} accessibilityRole="header">
      <Text style={posUi.sectionTitle}>{title}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    marginTop: spacing.sm,
    marginBottom: spacing.xs,
    alignSelf: 'stretch',
  },
});
